exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fix-ovefflow-auto{overflow:auto}.online-chat{height:485px;overflow-y:auto}.video-frame{margin:0;padding:0;border:0;vertical-align:baseline}.novideo-frame,.video-frame{width:100%;height:440px}.is-full-view .novideo-frame,.is-full-view .video-frame{width:100%;height:523px}.video-js{border-radius:4px}.video-frame video{border-radius:3px}.team-alert{width:150px}@media only screen and (max-width:768px){.visiable-mobile-sidebar{display:block!important;position:fixed;z-index:9999;background-color:#f8f9fa;height:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-98060e04","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 377
// module chunks = 0